<template>
    <div>
        <div class="w-fit flex items-center text-14">
            <component
                :is="color(uploadItem) == 'doc' ? 'IconNote' : 'IconPhotos'"
                :class="[
                    uploadErrors.length > 0 ? 'stroke-red-700' : 'stroke-grey-800',
                    {
                        'h-4 w-4': color(uploadItem) == 'doc',
                        'w-4 h-4': color(uploadItem) == 'img',
                    },
                ]"
            />
            <p class="text-14 pl-2" :class="[uploadErrors.length > 0 ? 'text-red-700' : '']">
                {{ truncateFileName(uploadItem) }}
            </p>

            <input type="hidden" :value="uploadItem.id" name="attachments[]" />
        </div>

        <p v-if="uploadErrors.length > 0" class="text-black text-13 pl-6">
            <span class="block" v-for="e in uploadErrors" v-text="e" />
        </p>
    </div>
</template>

<script>
import Upload from '~/models/upload.js'

export default {
    props: {
        upload: Object,
    },

    methods: {
        color(upload) {
            let ext = upload.file_name.split('.')
            if (ext.length == 0) {
                return 'doc'
            }
            ext = ext[ext.length - 1]

            return ['jpg', 'png', 'jpeg', 'svg', 'gif'].indexOf(ext) >= 0 ? 'img' : 'doc'
        },

        truncateFileName(upload) {
            if (upload.name == undefined) {
                return 'undefined'
            }

            let split = String(upload.name).split('.')
            let n = upload.name.replace('.' + upload.extention, '')

            if (split.length == 0 || n.length <= 20) {
                return upload.name
            }

            return n.slice(0, 19) + '~.' + upload.extention
        },
    },

    computed: {
        uploadItem() {
            return this.upload.upload !== undefined ? this.upload.upload : this.upload
        },

        uploadErrors() {
            let a = JSON.parse(this.uploadItem.errors)

            return !a ? [] : a
        },
    },
}
</script>
